import styled from 'styled-components';
import { QuillContainer } from '../ComplexDocumentDesign/styles';
import { MailSettingsTab, OverflowContainer, TabMenuItemContainer } from '../SidebarMenu/styles';

export const PointerDiv = styled(QuillContainer)`
  cursor: pointer;

  * {
    cursor: pointer;
  }
`;

export const AttachmentsTab = styled(MailSettingsTab)`
  height: 80%;

  .ant-tabs {
    height: 100%;
  }

  .ant-tabs-content {
    height: 100%;
  }

  ${OverflowContainer} {
    height: 100%;
  }

`;

export const EditorWrapper = styled.div`
  width: 100%;
  padding: 24px 0px;
  display: flex;
  padding-left: ${props =>props.dndFlow && '10px'};
  position: relative;
  @media only screen and (max-width: 1440px) {
    padding-right: 10px !important;
  }
`;

export const PagesWrapper = styled.div`
  width: 100%;
  height: calc(100% - 70px);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // background-color: #F5F8FA;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const CustomTabMenuItemContainer = styled(TabMenuItemContainer)`
  z-index: auto;
`;